import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "more-box__val"
};
var _hoisted_2 = { class: "filt-box__main" };
var _hoisted_3 = { class: "filt-box__prices" };
var _hoisted_4 = { class: "f-price__prices-slider" };
var _hoisted_5 = { class: "f-price__main" };
var _hoisted_6 = { class: "f-price__range" };
var _hoisted_7 = { class: "filt-box__prices-range" };
var _hoisted_8 = { class: "filt-box__prices-start price-start" };
var _hoisted_9 = { class: "filt-box__prices-end price-end" };
import { computed, onBeforeUnmount, onMounted, ref, shallowRef, watch } from "vue";
import { create } from "nouislider";
import { format } from "../../../utils";
import ItemWrapper from "./ItemWrapper.vue";
var STEP = 100;
export default /*@__PURE__*/ _defineComponent({
    __name: 'RangeItem',
    props: {
        item: { type: Object, required: true },
    },
    emits: ["update"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var slider = shallowRef();
        var rangeElement = ref();
        var min = computed(function () { return Math.floor(props.item.available.min / STEP) * STEP; });
        var max = computed(function () { return Math.max(Math.ceil(props.item.available.max / STEP) * STEP, min.value + STEP); });
        var disabled = computed(function () { return props.item.available.min >= props.item.available.max; });
        var formattedMin = ref(format(props.item.value.min ? props.item.value.min : min.value));
        var formattedMax = ref(format(props.item.value.max ? props.item.value.max : max.value));
        var formattedMinValue = computed(function () { return format(props.item.value.min); });
        var formattedMaxValue = computed(function () { return format(props.item.value.max); });
        var config = {
            start: [
                props.item.value.min ? props.item.value.min : min.value,
                props.item.value.max ? props.item.value.max : max.value,
            ],
            connect: true,
            step: STEP,
            range: {
                min: min.value,
                max: max.value,
            },
        };
        function toggleDisabled() {
            var _a, _b;
            if (disabled.value) {
                (_a = slider.value) === null || _a === void 0 ? void 0 : _a.disable();
            }
            else {
                (_b = slider.value) === null || _b === void 0 ? void 0 : _b.enable();
            }
        }
        function reset() {
            var _a, _b;
            props.item.value.min = 0;
            props.item.value.max = 0;
            (_a = slider.value) === null || _a === void 0 ? void 0 : _a.reset();
            (_b = slider.value) === null || _b === void 0 ? void 0 : _b.set([props.item.available.min, props.item.available.max]);
            emit('update', false);
        }
        watch([min, max], function () {
            var _a, _b;
            (_a = slider.value) === null || _a === void 0 ? void 0 : _a.updateOptions({
                range: {
                    min: min.value,
                    max: max.value,
                }
            }, true);
            if (!props.item.active) {
                (_b = slider.value) === null || _b === void 0 ? void 0 : _b.set([min.value, max.value], true);
            }
        });
        watch(disabled, toggleDisabled);
        watch(function () { return props.item; }, function () {
            var _a, _b;
            if (props.item.value.min || props.item.value.max) {
                (_a = slider.value) === null || _a === void 0 ? void 0 : _a.set([props.item.value.min, props.item.value.max], true);
            }
            else {
                (_b = slider.value) === null || _b === void 0 ? void 0 : _b.set([min.value, max.value], true);
            }
        });
        onMounted(function () {
            if (!rangeElement.value) {
                return;
            }
            slider.value = create(rangeElement.value, config);
            toggleDisabled();
            slider.value.on('change', function (_values, _handle, unencoded) {
                var selectedMin = Math.round(unencoded[0]);
                var selectedMax = Math.round(unencoded[1]);
                if (selectedMin !== min.value || selectedMax !== max.value) {
                    props.item.value.min = selectedMin;
                    props.item.value.max = selectedMax;
                    emit('update', true);
                }
                else {
                    props.item.value.min = 0;
                    props.item.value.max = 0;
                    emit('update', true);
                }
            });
            slider.value.on('update', function (values) {
                formattedMin.value = format(parseInt(String(values[0])));
                formattedMax.value = format(parseInt(String(values[1])));
            });
        });
        onBeforeUnmount(function () { var _a; return (_a = slider.value) === null || _a === void 0 ? void 0 : _a.destroy(); });
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(ItemWrapper, {
                item: __props.item,
                onReset: reset
            }, {
                badge: _withCtx(function () { return [
                    (__props.item.active)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(formattedMinValue.value) + " – " + _toDisplayString(formattedMaxValue.value), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                ]; }),
                body: _withCtx(function () { return [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("div", {
                                            ref_key: "rangeElement",
                                            ref: rangeElement
                                        }, null, 512 /* NEED_PATCH */)
                                    ])
                                ])
                            ]),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, _toDisplayString(formattedMin.value), 1 /* TEXT */),
                                _cache[0] || (_cache[0] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_9, _toDisplayString(formattedMax.value), 1 /* TEXT */)
                            ])
                        ])
                    ])
                ]; }),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["item"]));
        };
    }
});
